import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
const core = o_util.core ?? {};
const coerce = core.coerce;
const deserialize = core.deserialize;
const isEmptyObject = core.isEmptyObject;
const isPlainObject = core.isPlainObject;
const serialize = core.serialize;
const serializeForm = core.serializeForm;
export {
  coerce,
  core,
  deserialize,
  isEmptyObject,
  isPlainObject,
  serialize,
  serializeForm
};
/*                                    */
